// src/payments/tiers.js
// Single source of truth for token pricing — used by TokenModal (post-login purchase)
// and LandingPage (public pricing section), so the two can never drift.
export const TIERS = [
  { tokens: 5,   label: "Starter",  price: "$1.00",  desc: "Try it out",                tier: "starter",  highlight: false },
  { tokens: 30,  label: "Explorer", price: "$5.00",  desc: "Great for regular practice", tier: "explorer", highlight: false },
  { tokens: 125, label: "Learner",  price: "$20.00", desc: "Most popular",               tier: "learner",  highlight: true  },
  { tokens: 350, label: "Family",   price: "$50.00", desc: "Perfect for families",       tier: "family",   highlight: false },
  { tokens: 750, label: "School",   price: "$100.00",desc: "For classrooms & schools",   tier: "school",   highlight: false },
];
